<script setup lang="ts">
import { ComboboxInput } from "reka-ui";
import { useTemplateRef, type InputHTMLAttributes } from "vue";

interface Props extends /* @vue-ignore */ InputHTMLAttributes {}

defineProps<Props>();

const modelValue = defineModel<string>();

function handleInput(evt: InputEvent) {
	evt.stopImmediatePropagation();
}

const inputRef = useTemplateRef("$input");
defineExpose({ input: inputRef });
</script>

<template>
	<ComboboxInput
		ref="$input"
		v-model="modelValue"
		class="w-4 min-w-4 grow"
		:displayValue="() => ''"
		@input="handleInput"
	/>
</template>
